import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ValidateSchema } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';

@Component({
  selector: 'app-modal-validate-commission',
  templateUrl: './modal-validate-commission.component.html',
  styleUrls: ['./modal-validate-commission.component.css']
})
export class ModalValidateCommissionComponent implements OnInit {

  @Input() listValidateSchema: ValidateSchema[]=[];

  @Input() esquema: string;
  @Input() fondeo : string; 
  @Input() linea : string;
  @Input() estructura: string;
  @Input() puesto: string;

  public mode : string; 
  public title: string;

  constructor(private commissionSalePromotionsService:CommissionSalePromotionsService,
    private toastr:ToastrService,
    private modalService: NgbModal
    ) { }
    
    dtOptions={
      order:[],
      responsive: true,
    
      select: 'single',
      bLengthChange: true,
      searching :true,
      dom:'<"row"<"col"B><"col"<"text-center">><"col"f>><"row"<"col"t>><"row"<"col"p>>',
      buttons: ['csv', 'excel'],
      autoWidth:true,
      
      pageLength: 10,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        },
        // dom: 'Bfrtip',
        buttons: [
          'excel'
        ]
      }
    };

  ngOnInit() {
    if(this.mode==='detail') {
      this.title = 'DETALLE DE LA CONFIGURACIÓN';
      
    }
    console.log(this.listValidateSchema)

    let modalContent:any = $('.modal-content');
        modalContent.draggable({
          handle: '.card-header'
          // , drag: function() {
          //   document.querySelector<HTMLElement>(".card-modal").classList.add("backdrop-modal");
          // }
        });
  }

 

  close=()=> {
    this.modalService.dismissAll();
  }

}
